import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import { AnimatePresence } from "framer-motion"
import InfiniteScroll from "react-infinite-scroll-component"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import { CategorizedNotifications, WishamNotification } from "types/notification.types"
import { notificationValidators } from "utils/notifications"
import { useAppSelector } from "appRedux/hooks"
import { useLazyGetNotificationsQuery } from "appRedux/slices/notificationApiSlice"
import { increaseNotificationsPage } from "appRedux/slices/notificationSlice"
import LayoutFadeAnimation from "components/animations/LayoutFadeAnimation"
import Loading from "components/atoms/Loading"
import Notification from "components/molecules/Notification"
import { Subtitle } from "components/atoms/Subtitle"

type GeneralNotificationsProps = {
  categorizedNotifications: CategorizedNotifications;
}

export default function CategorizedNotificationsBasedOnTime(props: GeneralNotificationsProps) {
  const { categorizedNotifications } = props

  const notification = useAppSelector((state) => state.notification)

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const [triggerGetNotifications] = useLazyGetNotificationsQuery()

  function fetchMoreNotification() {
    if (!notification.hasMore) return
    triggerGetNotifications(notification.page + 1)
    dispatch(increaseNotificationsPage())
  }

  function shouldRenderNotification(notification: WishamNotification) {
    const validator = notificationValidators[notification.type]
    return validator ? validator(notification) : true
  }

  return (
    <Stack>
      <InfiniteScroll
        dataLength={notification.notifications.length}
        next={fetchMoreNotification}
        hasMore={notification.hasMore}
        loader={<Loading/>}
        scrollThreshold={"20px"}
      >
        <AnimatePresence>
          {(Object.keys(categorizedNotifications) as Array<keyof CategorizedNotifications>).map((category) => (
            categorizedNotifications[category].length > 0 ? (
              <LayoutFadeAnimation key={category}>
                <CategoryWrapper>
                  <Subtitle>{t(`general.${category}`)}</Subtitle>
                  <AnimatePresence>
                    {categorizedNotifications[category].map(notif => (
                      shouldRenderNotification(notif) ? <LayoutFadeAnimation key={notif.id}>
                        <Notification notification={notif}/>
                      </LayoutFadeAnimation> : null
                    ))}
                  </AnimatePresence>
                </CategoryWrapper>
              </LayoutFadeAnimation>
            ) : null
          ))}
        </AnimatePresence>
      </InfiniteScroll>
    </Stack>
  )
}

const CategoryWrapper = styled(Stack)({
  marginBottom: "8px"
})


